const purchaseType = {
    COMPRA: 1,
    SERVICIO: 2
}

const coins = {
    SOLES: { id: 1, simbolo: "S/", descripcion: "Soles" },
    DOLARES: { id: 2, simbolo: "$", descripcion: "Dolares" }
}

const accountType = {
    CORRIENTE: { id: 1, descripcion: "Corriente" },
    AHORROS: { id: 2, descripcion: "Ahorros" }
}

const roles = {
    GERENCIA: {
        id: 6,
        nombre: "GERENCIA"
    },
    ADMINISTRADOR: {
        id: 1,
        nombre: "ADMINISTRADOR"
    },
    ESTANDAR: {
        id: 2,
        nombre: "ESTANDAR"
    },
    LOGISTICA: {
        id: 3,
        nombre: "LOGISTICA"
    },
    CONTABILIDAD: {
        id: 4,
        nombre: "CONTABILIDAD"
    },
    INVENTARIO: {
        id: 5,
        nombre: "INVENTARIO"
    },
    TESORERIA: {
        id: 7,
        nombre: "TESORERIA"
    },
}

const taxesType = {
    IGV: "IGV",
    PERCEPCION: "Percepción",
    DETRACCION: "Detracción"
}

const purchaseStatus = {
    CREADO: { id: 1, class: "is-light" },
    APROBACION_GERENCIA: { id: 2, class: "is-warning" },
    EMITIDO: { id: 3, class: "is-info" },
    PAGADO: { id: 4, class: "is-success" },
    RECEPCIONADO: { id: 5, class: "is-success" },
    FABRICA: { id: 6, class: "is-warning" },
    PUERTO_ORIGEN: { id: 7, class: "is-warning" },
    TRANSITO: { id: 8, class: "is-warning" },
    PUERTO_DESTINO: { id: 9, class: "is-warning" },
    ALMACEN_ADUANA: { id: 10, class: "is-warning" },
    ANULADO: { id: 11, class: "is-danger" },
    PAGO_PARCIAL: { id: 13, class: "is-warning" },
}

const estados = {
    creado: {
        id: "CRE",
        class: "nj-button",
    },
    por_aprobar: {
        id: "POA",
        class: "nj-button c-yellow",
    },
    aprobado: {
        id: "APR",
        class: "nj-button c-green",
    },
    desaprobado: {
        id: "DES",
        class: "nj-button c-red",
    },
    cancelado: {
        id: "CAN",
        class: "nj-button c-red",
    },
    depositado: {
        id: "DEP",
        class: "nj-button c-blue",
    },
}

export {
    purchaseType,
    coins,
    accountType,
    roles,
    taxesType,
    purchaseStatus,
    estados
}